import { ListingOtQuery } from '../../graphql-types';

export const getPrices = (ots: ListingOtQuery['allIngenieOt']['nodes']) => {
  const prices = ots?.reduce(
    (acc, current) => {
      const currentMin = current.criteres210?.prix?.min ?? 0;
      const currentMax = current.criteres210?.prix?.max ?? 0;
      return {
        min: currentMin < acc.min ? currentMin : acc.min,
        max: currentMax > acc.max ? currentMax : acc.max,
      };
    },
    { min: 100000, max: 0 }
  );
  return prices?.min > prices?.max ? { min: 0, max: 0 } : prices;
};
